import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { selectIsMobile } from "modules/deviceInfo";
import { useSelector } from "react-redux";
import {
  isAgencyWhiteLabellingEnabled,
  isWhiteLabellingEnabled,
} from "modules/companyPlanSettings/utils/whitelabel";
import { ExitDoorEdit } from "modules/eventExit";
import { CustomBranding } from "../CustomBranding";
import CompanyBadge from "../../companyBadge/CompanyBadge";
import { AgencyWhiteLabel } from "../AgencyWhiteLabel";

export const WhiteLabelSettings = (): JSX.Element => {
  const { hasCustomExitPage, myCompanyPlan } = useCompanyPlanSettings();
  const enableExitPage = hasCustomExitPage(myCompanyPlan);
  const enableWhitelabelling = isWhiteLabellingEnabled(myCompanyPlan);
  const enabledAgencyWhiteLabelling =
    isAgencyWhiteLabellingEnabled(myCompanyPlan);
  const isMobileView = useSelector(selectIsMobile);

  return (
    <>
      {(enableExitPage && !isMobileView && <ExitDoorEdit />) || null}
      <CompanyBadge />
      <CustomBranding enableWhitelabelling={enableWhitelabelling} />
      <AgencyWhiteLabel
        enabledAgencyWhiteLabelling={enabledAgencyWhiteLabelling}
      />
    </>
  );
};
